import { render, staticRenderFns } from "./Practise.vue?vue&type=template&id=31f4610a&"
import script from "./Practise.vue?vue&type=script&lang=js&"
export * from "./Practise.vue?vue&type=script&lang=js&"
import style0 from "./Practise.vue?vue&type=style&index=0&id=31f4610a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports